import {
  SCHEDULE_FILTER_COUNT_ZERO,
  SCHEDULE_FILTER_KEY,
  SCHEDULE_FILTER_WITH_NEW_CLIENTS_VISIBLE,
} from './ScheduleFilterChips.constants';
import { messages } from './ScheduleFilterChips.messages';

function toScheduleFilterCount(count) {
  return count ?? SCHEDULE_FILTER_COUNT_ZERO;
}

export function isScheduleFilterRailEmpty(counts = {}) {
  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  return activeClasses === SCHEDULE_FILTER_COUNT_ZERO && disabledClasses === SCHEDULE_FILTER_COUNT_ZERO;
}

export function getDefaultScheduleFilterKey(counts = {}, isManualStudio = false) {
  if (isScheduleFilterRailEmpty(counts)) {
    return null;
  }

  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  if (!isManualStudio && activeClasses === SCHEDULE_FILTER_COUNT_ZERO && disabledClasses > SCHEDULE_FILTER_COUNT_ZERO) {
    return SCHEDULE_FILTER_KEY.DISABLED_CLASSES;
  }

  return SCHEDULE_FILTER_KEY.ACTIVE_CLASSES;
}

function buildOption({ key, label, count, disabled = false }) {
  return { key, label, count, disabled };
}

function buildZeroDisabledOption({ key, label, count }) {
  return buildOption({
    key,
    label,
    count,
    disabled: count === SCHEDULE_FILTER_COUNT_ZERO,
  });
}

export function getVisibleScheduleFilterOptions({
  counts = {},
  formatMessage,
  hasSpotManagePermission = true,
  isManualStudio = false,
}) {
  if (isScheduleFilterRailEmpty(counts)) {
    return [];
  }

  const activeClasses = toScheduleFilterCount(counts.activeClasses);
  const withReservations = toScheduleFilterCount(counts.withReservations);
  const withNewClients = toScheduleFilterCount(counts.withNewClients);
  const withClientsWaiting = toScheduleFilterCount(counts.withClientsWaiting);
  const disabledClasses = toScheduleFilterCount(counts.disabledClasses);

  const options = [
    buildZeroDisabledOption({
      key: SCHEDULE_FILTER_KEY.ACTIVE_CLASSES,
      label: formatMessage(messages.activeClasses),
      count: activeClasses,
    }),
    buildZeroDisabledOption({
      key: SCHEDULE_FILTER_KEY.WITH_RESERVATIONS,
      label: formatMessage(messages.withReservations),
      count: withReservations,
    }),
  ];

  if (SCHEDULE_FILTER_WITH_NEW_CLIENTS_VISIBLE) {
    options.push(
      buildZeroDisabledOption({
        key: SCHEDULE_FILTER_KEY.WITH_NEW_CLIENTS,
        label: formatMessage(messages.withNewClients),
        count: withNewClients,
      })
    );
  }

  if (hasSpotManagePermission && withClientsWaiting > SCHEDULE_FILTER_COUNT_ZERO) {
    options.push(
      buildOption({
        key: SCHEDULE_FILTER_KEY.WITH_CLIENTS_WAITING,
        label: formatMessage(messages.withClientsWaiting),
        count: withClientsWaiting,
      })
    );
  }

  if (!isManualStudio && disabledClasses > SCHEDULE_FILTER_COUNT_ZERO) {
    options.push(
      buildOption({
        key: SCHEDULE_FILTER_KEY.DISABLED_CLASSES,
        label: formatMessage(messages.disabledClasses),
        count: disabledClasses,
      })
    );
  }

  return options;
}
